import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import ModalStore from '../../../Modal/Store';
import GroupParticipantsStore from '../GroupParticipantsStore/Store';
import { GroupParticipantsResource } from '../GroupParticipantsStore/Types';
import Table from './Table';
import EmptyTable from './EmptyTable';

interface Props {
  groupParticipantsStore: GroupParticipantsStore;
  modalStore: ModalStore;
  groupParticipantsResource: GroupParticipantsResource;
}

function Body({ groupParticipantsStore, modalStore, groupParticipantsResource }: Props) {
  return fromEmpty(groupParticipantsResource.payload.participants.payload.participants)
    .map((participants) => (
      <Table
        groupParticipantsStore={groupParticipantsStore}
        participants={participants}
        groupParticipantsResource={groupParticipantsResource}
      />
    ))
    .getOrElse(() => (
      <EmptyTable
        groupParticipantsStore={groupParticipantsStore}
        openModal={modalStore.open}
        allParticipantIds={groupParticipantsResource.payload.allParticipantIds}
      />
    ));
}

export default observer(Body);
